export default {
  id: null,
  horasAusente: null,
  mensagem: null,
  finalizaConversa: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/mensagemausentemodel.js